module.exports = __webpack_public_path__ + "img/ENFJ.53934352.png";